var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"item-education w-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"information"},[_c('h3',[_vm._v(_vm._s(_vm.label)+" : ")]),_vm._v(" "+_vm._s(_vm.showLabel(_vm.item))+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }